export const initialValuesForm = {
  cadastroSocialLogin: false,
  antiFraudActive: true,
  acessoSemLinkParceiro: true,
  firstName: "",
  lastName: "",
  birthDate: "",
  whatsapp: "",
  email: "",
  name: "",
  cpf: "",
  cnpj: "",
  personType: "PF",
  cpfCnpj: "",
  companyName: "",
  billValue: "",
  cupom: "",
  province: "",
  howDidYouGetUs: "",
  zipCode: "",
  street: "",
  number: "",
  complement: "",
  neighborhood: "",
  city: "",
  password: "",
  idCompany: "",
  creditLimit: "",
  newPassword: "",
  confirmPassword: "",
  useReverseSimulator: false,
  agreeToSms: true,
  agreeToWhatsapp: true,
  agreeToEmail: true,
  reverseSimulator: "N",
  prazoQuitar: "72horas",
  deviceIdQuitaBoletos: localStorage.getItem("deviceIdQuitaBoletos"),
};
